export const en = {
  employeesPage: {
    title: 'All Employees',
    helmet: {
      title: 'Employees',
      invitesTitle: 'Employees › Invites',
    },
    table: {
      searchPlaceholder: 'Search Employees',
      columns: {
        name: 'Name',
        role: 'Role',
        lastActive: 'Last Active',
        causePreferences: 'Cause Preferences',
        department: 'Department',
        email: 'Email',
        status: 'Status',
        employmentType: 'Employment Type',
      },
      roles: {
        admin: 'Admin',
        employee: 'Employee',
        deactivated: 'Deactivated',
      },
      employmentTypes: {
        salaried: 'Salaried',
        union: 'Union',
        unassigned: 'Unassigned',
      },
      actions: {
        makeAdmin: 'Make Admin',
        removeAdmin: 'Remove Admin',
        deactivate: 'Deactivate Employee',
        activate: 'Activate Employee',
        updateEmploymentType: 'Update Employment Type',
        copyEmail: 'copied to your clipboard',
      },
    },
    emptyState: {
      title: 'No employees yet',
      description:
        "Looks like you haven't added any employees yet.\nAdd employees to start collaborating with your team!",
    },
    invites: {
      emptyState: {
        title: 'No invites have been sent yet',
        description:
          'Invite employees to join Purposely and start volunteering together!',
      },
      status: {
        invited: 'Invited',
        fulfilled: 'Fulfilled',
      },
    },
    buttons: {
      inviteEmployee: 'Invite Employee',
      all: 'All',
      invited: 'Invited',
    },
    modals: {
      updateAdmin: {
        title: 'Update Employee Admin',
        removeConfirm:
          'Are you sure you want to remove {{name}} as an administrator of your company?',
        makeConfirm:
          'Are you sure you want to make {{name}} an administrator of your company?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
        messages: {
          success: 'Successfully updated admin privileges',
          error: 'Unable to update employee. Try again later.',
        },
      },
      updateEmploymentType: {
        title: 'Update Employment Type',
        description: 'Select the employment type for {{name}}',
        types: {
          salaried: 'Salaried',
          union: 'Union',
        },
        buttons: {
          cancel: 'Cancel',
          confirm: 'Update',
        },
        messages: {
          success: 'Successfully updated employment type',
          error: 'Unable to update employment type. Try again later.',
        },
      },
      changeActive: {
        title: {
          deactivate: 'Deactivate Employee',
          activate: 'Activate Account',
        },
        confirm: {
          deactivate:
            'Are you sure you want to deactivate {{name}}? This will cause them to lose access to their account.',
          activate:
            'Are you sure you want to activate {{name}}? This will give them access to their account.',
        },
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
        messages: {
          success: 'Successfully changed active status',
          error: 'Unable to change active status. Try again later.',
        },
      },
      inviteEmployees: {
        title: 'Invite Employee',
        confirmationTitle: 'Invitations Sent',
        form: {
          emailField: {
            label: 'Invite by email',
            placeholder:
              'Enter an email or bulk invite by entering multiple emails separated by commas.',
            hint: "All emails must match your company's domain ({{domain}}). To invite multiple employees, separate individual emails by commas.",
          },
          csvImport: '+ Import from CSV',
          submit: 'Send Invite',
          errors: {
            required: 'Required.',
            invalidEmail: 'Invalid email {{email}}',
            invalidDomain: 'Invalid domain {{domain}}',
            generic: 'An error occurred while sending invites.',
            validation: 'Please fix the errors below and try again.',
          },
        },
        confirmation: {
          button: 'Sounds Good',
        },
      },
    },
  },
}
